import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';

export const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative pt-64 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-teal-100 rounded-full filter blur-3xl opacity-30 -z-10"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-cyan-100 rounded-full filter blur-3xl opacity-30 -z-10"></div>

      <div className="container mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-block">
              <span className="bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold">
                Trusted Medical Equipment Solutions
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
              Premium Refurbished Medical Equipment
              <span className="text-teal-600"> Across India</span>
            </h1>

            <p className="text-lg text-slate-600 leading-relaxed">
              Upline Global Solutions specializes in the sale and service of certified refurbished CT, MRI, Cath Labs, and PET CT systems. Quality healthcare solutions that don't compromise on excellence.
            </p>

            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <CheckCircle2 className="text-teal-600 flex-shrink-0" size={20} />
                <span className="text-slate-700">Certified & Tested Equipment</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle2 className="text-teal-600 flex-shrink-0" size={20} />
                <span className="text-slate-700">Pan India Service Coverage</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle2 className="text-teal-600 flex-shrink-0" size={20} />
                <span className="text-slate-700">Expert Technical Support</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={scrollToContact}
                size="lg"
                className="bg-teal-600 hover:bg-teal-700 text-white transition-colors group"
              >
                Request a Quote
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
              <Button
                onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                size="lg"
                variant="outline"
                className="border-2 border-teal-600 text-teal-600 hover:bg-teal-50 transition-colors"
              >
                Explore Services
              </Button>
            </div>
          </div>

          {/* Right Content - Stats Cards */}
          <div className="grid grid-cols-2 gap-6">
            <div className="bg-white rounded-2xl p-6 shadow-xl border border-slate-100 hover:shadow-2xl transition-shadow">
              <div className="text-4xl font-bold text-teal-600 mb-2">20+</div>
              <div className="text-slate-600 font-medium">Years of Experience</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-xl border border-slate-100 hover:shadow-2xl transition-shadow mt-8">
              <div className="text-4xl font-bold text-teal-600 mb-2">65+</div>
              <div className="text-slate-600 font-medium">Equipment Installed</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-xl border border-slate-100 hover:shadow-2xl transition-shadow">
              <div className="text-4xl font-bold text-teal-600 mb-2">28+</div>
              <div className="text-slate-600 font-medium">Cities Covered</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-xl border border-slate-100 hover:shadow-2xl transition-shadow mt-8">
              <div className="text-4xl font-bold text-teal-600 mb-2">50+</div>
              <div className="text-slate-600 font-medium">Happy Clients</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};